import decode from 'jwt-decode'

export function getUserIdFromJWT(token) {
  const decoded = decode(token)
  const id = decoded?.id ?? null
  return id
}
